"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authActions = void 0;
var _reduxActions = require("redux-actions");
var authActions = exports.authActions = (0, _reduxActions.createActions)({
  SET_LANG: function SET_LANG(lang) {
    return lang;
  },
  SET_API_KEY: function SET_API_KEY(key) {
    return key;
  },
  SET_THEME: function SET_THEME(theme) {
    return theme;
  },
  SET_SESSION: function SET_SESSION(session) {
    return session;
  }
}, {
  prefix: 'tourscaner'
});